export default __webpack_public_path__ + "static/media/add.0bcc7c47.svg";